import { AmProject } from "../../ps-types";
import { useCompanyId } from "../../core";
import { JobProgress, JobProgressData } from "../JobProgress";
import { getWorkflowLogs } from "./amProjectSync.client";
import { SmallLoading } from "../../ui/Loading";
import { useEffect, useState } from "react";

export interface SpvExecutionLogEntry {
  time: number;
  type: string;
  message?: string;
  level?: string;
  spvId?: string;
  status?: string;
}

export function ExecutionLogs({
  executionId,
  projects,
  initialJobProgress
}: {
  executionId: string;
  projects: AmProject[];
  initialJobProgress: any;
}) {
  const companyId = useCompanyId();
  const [loading, setLoading] = useState<boolean>(false)
  useEffect(()=>{
    setLoading(true)
  }, [])
  const reloadLogs = async (executionId: string) => {
    let logs = { log: [], status: "" };
    logs = await getWorkflowLogs(companyId, executionId);
    setLoading(false)
    const completedLogsCount = logs.log.filter((log: SpvExecutionLogEntry) => log?.status === "completed").length;
    return {
      logEntries: logs.log || [],
      total: completedLogsCount,
    } as JobProgressData;
  };

  return (
    <>
      {loading && <SmallLoading message="loading logs" />}
      <JobProgress
        projects={projects}
        initialJobProgress={initialJobProgress}
        refreshLogs={() => {
          return reloadLogs(executionId);
        }}
      />
    </>
  );
}
